import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { useDispatch } from "react-redux";
import { setActiveContact } from "./contactSlice";
import { useLocation } from "react-router-dom";
import EntityWrapper from "../../../components/crm/style/EntityWrapper.style";
import Activity from "../../../components/crm/components/activity/Activity";
import ContactDetails from "../../../components/crm/components/ContactDetails";
import EntityActions from "../../../components/crm/components/entityActions";
import Feed from "../../../components/crm/components/feed/Feed";
import { useSelector } from "react-redux";
import CrmTemplate from "../../../components/crm/CrmTemplate";
import EntityFormModal from "../../../components/crm/forms/EntityFormModal";
const { Sider, Content } = Layout;

const Contact = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const activeContact = useSelector((state) => state.contact.activeContact);
  const [entityModalVisible, setEntityModalVisible] = useState(false);

  useEffect(() => {
    const record = location.state;
    if (record) {
      dispatch(setActiveContact({ record }));
    }

    return function cleanup() {
      // dispatch(reset());
    };
  }, [location]);

  const onEdit = () => {
    setEntityModalVisible(true);
  };

  const hideContactModal = () => {
    setEntityModalVisible(false);
  };

  const onDelete = () => {};

  return (
    <CrmTemplate>
      <EntityWrapper>
        <Layout>
          <Sider
            width="350px"
            style={{ background: "transparent" }}
            className="fixed-position"
          >
            <EntityActions
              type={"lead"}
              onEdit={onEdit}
              onDelete={onDelete}
              record={activeContact}
            />
            <ContactDetails record={activeContact} />
            <Feed />
          </Sider>
          <Content>
            <Activity entity={2} />
          </Content>
        </Layout>
      </EntityWrapper>
      <EntityFormModal
        visible={entityModalVisible}
        record={activeContact}
        hide={hideContactModal}
        mode={"edit"}
        entity={"contacts"}
      />
    </CrmTemplate>
  );
};

export default Contact;
